import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { isSubscriptionShapeBookClub, isSubscriptionShapeDigitalService, isSubscriptionShapeSeries, isSubscriptionShapeSubscription, } from "../../subscription-plan/selectors/isSubscriptionShape.js";
import { getSubscriptionType } from "./getSubscriptionType.js";
export const getSubscriptionVariantProductSelector = (subscription) => {
    const subscriptionType = getSubscriptionType(subscription);
    const isSeries = isSubscriptionShapeSeries(subscriptionType);
    const isBookSubscription = isSubscriptionShapeSubscription(subscriptionType);
    const isBookClub = isSubscriptionShapeBookClub(subscriptionType);
    const isDigitalService = isSubscriptionShapeDigitalService(subscriptionType);
    if (isDigitalService)
        return undefined;
    let showBookSelectorId;
    if (isSeries) {
        showBookSelectorId =
            CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.VARIANT
                .SHOW_BOOK_SELECTOR;
    }
    if (isBookSubscription) {
        showBookSelectorId =
            CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION.VARIANT.SHOW_BOOK_SELECTOR;
    }
    if (isBookClub) {
        showBookSelectorId =
            CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.VARIANT.SHOW_BOOK_SELECTOR;
    }
    if (!showBookSelectorId)
        throw new Error(`Unsupported subscription shape for product selector - Sku ${subscription?.sku}`);
    return getComponentContentById(subscription.components, showBookSelectorId)?.value;
};
